import { createIcon } from '../createIcon';

export const LaptopMedicalIconConfig = {
  name: 'LaptopMedicalIcon',
  height: 512,
  width: 640,
  svgPath: 'M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const LaptopMedicalIcon = createIcon(LaptopMedicalIconConfig);

export default LaptopMedicalIcon;